import { PedologyGrouped } from "../../models/Pedology";
import { cloneObject } from "./utils";

export interface MapsTabState {
    readonly loadingPedology: boolean;
    readonly pedologyGroupedData: PedologyGrouped[];
    readonly openTags: string[];
    readonly pedologySelected: PedologyGrouped | null;
}

export const mapTabDefault: MapsTabState =  {
    loadingPedology: false,
    pedologyGroupedData: [],
    openTags: [],
    pedologySelected: null
}


export const mapStateLoading = (mapState: MapsTabState, stateLoading: boolean) => {
    mapState = {
        loadingPedology: stateLoading,
        pedologyGroupedData: cloneObject(mapState.pedologyGroupedData),
        openTags: cloneObject(mapState.openTags),
        pedologySelected: cloneObject(mapState.pedologySelected),
    };
}

export const mapStateUpdateSelected = (mapState: MapsTabState, pedologySelected: PedologyGrouped | null) => {
    mapState = {
        loadingPedology: mapState.loadingPedology,
        pedologyGroupedData: cloneObject(mapState.pedologyGroupedData),
        openTags: cloneObject(mapState.openTags),
        pedologySelected: pedologySelected,
    };
}

export const mapLoadingState = (mapState: MapsTabState): MapsTabState => {
    return {
        loadingPedology: true,
        pedologyGroupedData: [],
        openTags: cloneObject(mapState.openTags),
        pedologySelected: cloneObject(mapState.pedologySelected)
    };
}

export const mapStateReset = (mapState: MapsTabState): MapsTabState => {
    return {
        loadingPedology: mapState.loadingPedology,
        pedologyGroupedData: [],
        openTags: cloneObject(mapState.openTags),
        pedologySelected: cloneObject(mapState.pedologySelected)
    };
}
